import {Outlet} from 'react-router-dom'
import {AppBackdrop} from '../../theme/AppBackdrop'

// The error pages use the public pages' look (site backdrop and one white tile) and still move on
// to the dashboard after two seconds.
const ErrorsLayout = () => {
  setTimeout(() => {
    window.location.replace('/dashboard')
  }, 2000)

  return (
    <div className='asa-public-page asa-error-page'>
      <AppBackdrop site />
      <main className='card asa-public-page__tile asa-error-page__tile'>
        <div className='card-body'>
          <Outlet />
        </div>
      </main>
    </div>
  )
}

export {ErrorsLayout}
